module.exports = __webpack_public_path__ + "static/media/desktop-img.3d8681a7.svg";